define('lq/services/action/pasteCommand',[
    'jquery',
    'underscore'
], function ($, _) {
    'use strict';

    var filePastedEvent = 'filePasted';
    var textPastedEvent = 'textPasted';

    function PasteCommand(data, rootDrop) {
        this.data = data;
        this.rootDrop = rootDrop;
        this.onPaste = this.handlePaste.bind(this);
    };

    PasteCommand.typeName = 'PasteCommand';

    PasteCommand.prototype.initialize = function () {
        if (!this.shouldListenForPaste()) return;
        this.addEventHandlers();
    };

    PasteCommand.prototype.shouldListenForPaste = function () {
        return this.shouldListenFor(filePastedEvent) || this.shouldListenFor(textPastedEvent);
    };

    PasteCommand.prototype.shouldListenFor = function (eventName) {
        return this.data.eventing
            && this.data.eventing[eventName]
            && this.data.eventing[eventName].enabled;
    };

    PasteCommand.prototype.addEventHandlers = function () {
        document.addEventListener('paste', this.onPaste);
    };

    PasteCommand.prototype.handlePaste = function (event) {
        if (!this.rootDrop.piping) return;

        var items = (event.clipboardData || event.originalEvent.clipboardData).items;

        var image = _.find(items, function (item) { return item.kind === 'file'; });

        var self = this;
        if (image) {
            if (this.shouldListenFor(filePastedEvent))
                this.rootDrop.piping.eventing.publish(this.data.eventing[filePastedEvent].raisedEventName, null, image.getAsFile(), null, self.eventActionId);
        } else if (this.shouldListenFor(textPastedEvent)) {
            var text = _.find(items, function (item) { return item.kind === 'string'; });

            if (text) {
                text.getAsString(function (textData) {
                    self.rootDrop.piping.eventing.publish(self.data.eventing[textPastedEvent].raisedEventName, null, textData, null, self.eventActionId);
                });
            }
        }
    };

    PasteCommand.prototype.dispose = function () {
        document.removeEventListener('paste', this.onPaste);
        this.rootDrop = undefined;
    };

    return PasteCommand;
});
